module.exports = __webpack_public_path__ + "assets/img/hockey-logo.bedc4823.png";